import { useCallback } from 'react'
import { provisionedTargets } from '../../../../../../api/integrations'

export const KEY_TYPE_OPTIONS = [
  { label: 'int', value: 'int' },
  { label: 'bigint', value: 'bigint' },
  { label: 'string', value: 'string' }
]

export const COLUMN_TYPE_OPTIONS = [
  { label: 'int', value: 'int' },
  { label: 'bigint', value: 'bigint' },
  { label: 'string', value: 'string' },
  { label: 'text', value: 'text' },
  { label: 'decimal', value: 'decimal' },
  { label: 'bool', value: 'bool' },
  { label: 'datetime', value: 'datetime' },
  { label: 'date', value: 'date' },
  { label: 'json', value: 'json' },
  { label: 'array', value: 'array' }
]

export const sectionHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '4px'
}

export const rowStyle = {
  padding: '8px',
  marginBottom: '6px',
  borderRadius: '4px',
  backgroundColor: 'var(--color-neutral-100)'
}

export const errorStyle = {
  color: 'var(--color-danger-500)',
  fontSize: '14px',
  marginRight: 'auto'
}

export const emptyStyle = {
  color: 'var(--color-neutral-600)',
  fontStyle: 'italic',
  padding: '12px 0'
}

export const descriptionStyle = {
  padding: '10px 12px',
  background: 'var(--color-surface-secondary)',
  borderRadius: '4px',
  fontSize: '0.8125rem',
  lineHeight: 1.5,
  color: 'var(--color-text-secondary)',
  marginBottom: '12px'
}

export function getDefinition (target) {
  if (!target?.definition) return {}
  return typeof target.definition === 'string'
    ? JSON.parse(target.definition)
    : target.definition
}

export function normalizeKeyArray (val) {
  if (!val) return []
  return Array.isArray(val) ? val : [val]
}

export function useSaveDefinitionSection (target) {
  const { mutateAsync: modifyTarget } = provisionedTargets.useModifyProvisionedTargetTable()

  return useCallback(async (sectionUpdates) => {
    const current = getDefinition(target)
    const definition = { ...current, ...sectionUpdates }
    await modifyTarget({
      provisionedTargetTableId: target.provisionedTargetTableId,
      definition
    })
  }, [modifyTarget, target])
}
